import { render, staticRenderFns } from "./DocSummaryPartType.vue?vue&type=template&id=539709b6&scoped=true"
import script from "./DocSummaryPartType.vue?vue&type=script&lang=js"
export * from "./DocSummaryPartType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539709b6",
  null
  
)

export default component.exports